/* Mint-Cost-iPad › Hàng chờ ghép: dải đếm cao 48 (padding 12/16), 2 thẻ bằng nhau gap 16, thẻ padding 16 radius 18, dòng cao ≥ 64. Màu chỉ var(--…). */
.strip { display: flex; align-items: center; gap: 16px; margin-bottom: 14px; padding: 12px 16px; border-radius: 14px; background: var(--card); box-shadow: var(--sh); color: var(--tx2); }
.strip span { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; font-weight: var(--fw-label); }
.warn { color: var(--warn); }
.ok { color: var(--ok); }
.grid { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); gap: 16px; align-items: start; }
.card { padding: 16px; border-radius: 18px; background: var(--card); box-shadow: var(--sh); }
.card h2 { margin: 0 0 12px; font-size: 17px; font-weight: var(--fw-title); }
.sticky { position: sticky; top: 0; }
.sticky h2 { margin-bottom: 4px; }
.line { width: 100%; min-height: 64px; display: flex; align-items: center; gap: 12px; padding: 12px 14px; margin-bottom: 8px; box-sizing: border-box; border: 0; border-radius: 14px; background: var(--sub); box-shadow: none; color: var(--tx); font: inherit; text-align: left; cursor: pointer; }
.line[aria-pressed='true'] { background: var(--pri-bg); box-shadow: inset 0 0 0 1.5px var(--pri); }
.line:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
.line b { font-weight: var(--fw-label); white-space: nowrap; }
.lt { flex-grow: 1; min-width: 0; }
.name { font-weight: var(--fw-label); }
.sub { margin-top: 2px; font-size: 13px; color: var(--lb); }
.ref { font-size: 13px; color: var(--lb); }
.for { margin-bottom: 12px; font-size: 13px; color: var(--lb); }
.cand { display: flex; flex-direction: column; gap: 8px; padding: 14px; margin-bottom: 8px; border-radius: 14px; background: var(--sub); }
.ct { display: flex; align-items: center; gap: 10px; }
.ct b { flex-grow: 1; font-weight: var(--fw-label); }
.conf { padding: 3px 10px; border-radius: 999px; font-size: 13px; font-weight: var(--fw-label); }
.cOk { background: var(--ok-bg); color: var(--ok); }
.cWarn { background: var(--warn-bg); color: var(--warn); }
.cGray { background: var(--ctl); color: var(--tx2); }
.csub { font-size: 13px; color: var(--tx2); }
.why { font-size: 13px; color: var(--lb); }
.go { align-self: flex-start; }
.none { padding: 14px; border-radius: 14px; background: var(--warn-bg); color: var(--warn); }
.acts { display: flex; gap: 8px; margin-top: 10px; }
.ask { height: 44px; padding: 0 16px; border: 0; border-radius: 12px; background: var(--pri-bg); color: var(--link); font: inherit; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.ask:focus-visible { outline: 2px solid var(--pri); outline-offset: 2px; }
